import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'sa-ui';
import messages from './reportGeneralPanelMessages';
import { injectIntl } from 'react-intl';
import * as helpers from '../reportHelpers';
import LoadMore from '../LoadMore';

import './StudentsGradeTable.scss';
import StudentPerformanceSquare from '../StudentPerformanceSquare';

const StudentsGradeTable = (props) => {
  const [gradeLimit, setGradeLimit] = useState(10);

  return (
    <Card className="students-grade-table">
      <div>
        <h5 className="title mt-0">
          <i className="ti ti-stats-up mr-2" />
          {props.intl.formatMessage(messages.studentsGradeTitle)}
        </h5>
      </div>
      <div>
        <table className="default-table">
          <thead>
            <tr>
              <th>{props.intl.formatMessage(messages.studentsAZ)} (A-Z)</th>
              <th>{props.intl.formatMessage(messages.hitPercentage)} (%)</th>
              <th>{props.intl.formatMessage(messages.schoolCriteria)}</th>
            </tr>
          </thead>
          <tbody>
            {props.itens.students.slice(0, gradeLimit).map((s, index) => (
              <tr>
                <td>{s.studentName}</td>
                <td>
                  <StudentPerformanceSquare
                    percentGrade={s.percentHits}
                    color={helpers.getColor(s.percentHits)}
                    size={50}
                  />
                </td>
                <td>{s.studentGrade}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {props.itens.students.length > 10 ? (
          <LoadMore onClick={() => setGradeLimit(gradeLimit + 10)} />
        ) : (
          ''
        )}
      </div>
    </Card>
  );
};

StudentsGradeTable.propTypes = {};

StudentsGradeTable.defaultProps = {};

export default injectIntl(StudentsGradeTable);
